import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import GeneratePdf from './GeneratePdf';
import ModalMessage from '../../../../../shared/components/Modal';
import history from '../../../../../history';

class ImagenologiaForm extends Component {
    constructor() {
        super();
        this.state = {
            history: '',
            description: '',
            tecnic: '',
            opinion: '',
            observation: '',
            note: '',
            urlLogo: '',
            profile: [],
            third: [],
            pacient: [],
            age: '',
            birthday: null,
            today: new Date(),
            regime: '',
            openAlert: false,
            exist: false,
            profile: sessionStorage.getItem('perfil'),
            modalAlert: { message: '', color: '', title: '' },
            services: []
        }
    }

    componentDidMount() {
        this.loadDataHistory();//
        console.log("PROPSINFO",this.props)
    }

    handlerHistory = (history) => {
        this.setState({ history: history });
    }

    handlerDescription = (description) => {
        this.setState({ description: description });
    }

    handlerTecnic = (tecnic) => {
        this.setState({ tecnic: tecnic });
    }

    handlerOpinion = (opinion) => {
        this.setState({ opinion: opinion });
    }

    handlerObservation = (observation) => {
        this.setState({ observation: observation });
    }

    handlerNote = (note) => {
        this.setState({ note: note });
    }

    loadDataHistory = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-medicinanuclear/consultar-por-admision?id_historia=' + this.props.data.id_historia + '&id_admision=' + this.props.data.id_admision, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        }).then(response => {
            return response.json();
        })
            .then(data => {

                if (data.length > 0) {

                    this.setState({
                        exist: true,
                        history: data[0].antecedentes,
                        tecnic: data[0].tecnica,
                        description: data[0].descripcion,
                        opinion: data[0].opinion,
                        observation: data[0].observacion,
                        note: data[0].nota,
                    });
                }

            }).catch((error) => {
                console.error('Error:', error);
            });
    }

    generateReport() {
        const data = {
            fullname: this.props.data.nombres,
            documentNumber: this.state.pacient.num_documento,
            typeDocument: this.state.pacient.tip_documento,
            profile: this.state.profile,
            data: this.state.today,
            birthday: this.state.birthday,
            age: this.state.age,
            gender: this.state.pacient.sexo,
            address: this.state.pacient.direccion.direccion,
            city: this.state.pacient.direccion.ciudad,
            telephone: this.state.pacient.telefono1,
            third: this.state.third,
            regime: this.state.regime,
            services: this.state.services,
            history: this.state.history,
            tecnic: this.state.tecnic,
            description: this.state.description,
            opinion: this.state.opinion,
            observation: this.state.observation,
            note: this.state.note,
            urlLogo: this.state.urlLogo

        };

        GeneratePdf(data);
    }

    saveHistory = () => {

        const dataSend = {
            antecedentes: this.state.history,
            tecnica: this.state.tecnic,
            descripcion: this.state.description,
            opinion: this.state.opinion,
            observacion: this.state.observation,
            nota: this.state.note,
            id_historia: this.props.data.id_historia,
            id_admision: this.props.data.id_admision
        };

        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-medicinanuclear/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                if (response.status === 200) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.setState({
                    openAlert: true,
                    modalAlert: {
                        message: "Guardado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    }
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    render() {

        return (
            <div className="form" style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", width: '100%' }}>
                    {/* <div style={{ width: '40%' }}>
                        <div className="form__form-group">
                            <span className="form__form-group-label">Antecedentes</span>
                            <div className="form__form-group-field">
                                <textarea
                                    name="textarea-history"
                                    defaultValue={this.state.history === "" ? this.props.history.antecedentes : this.state.history}
                                    onChange={(e) => { this.handlerHistory(e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <span className="form__form-group-label">Técnica</span>
                            <div className="form__form-group-field">
                                <textarea
                                    name="textarea-tecnic"
                                    defaultValue={this.state.tecnic === "" ? this.props.history.tecnica : this.state.tecnic}
                                    onChange={(e) => { this.handlerTecnic(e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <span className="form__form-group-label">Descripción</span>
                            <div className="form__form-group-field">
                                <textarea
                                    name="textarea-descrip"
                                    defaultValue={this.state.description === "" ? this.props.history.descripcion : this.state.description}
                                    onChange={(e) => { this.handlerDescription(e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <span className="form__form-group-label">Opinión</span>
                            <div className="form__form-group-field">
                                <textarea
                                    name="textarea-opinion"
                                    defaultValue={this.state.opinion === "" ? this.props.history.opinion : this.state.opinion}
                                    onChange={(e) => { this.handlerOpinion(e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <span className="form__form-group-label">Observación</span>
                            <div className="form__form-group-field">
                                <textarea
                                    name="textarea-observ"
                                    defaultValue={this.state.observation === "" ? this.props.history.observacion : this.state.observation}
                                    onChange={(e) => { this.handlerObservation(e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>
                        <div className="form__form-group">
                            <span className="form__form-group-label">Nota</span>
                            <div className="form__form-group-field">
                                <textarea
                                    name="textarea-note"
                                    defaultValue={this.state.note === "" ? this.props.history.nota : this.state.note}
                                    onChange={(e) => { this.handlerNote(e.target.value) }}
                                >
                                </textarea>
                            </div>
                            {this.state.profile !== '16' ?
                            !this.state.exist ?
                                <Button
                                    style={{ marginTop: 50 }}
                                    onClick={() => {
                                        this.saveHistory()
                                    }}
                                >
                                    Guardar
                                </Button>
                                : null
                            :null}
                        </div>

                    </div> */}
                    <div style={{ width: '50%' }}>

                        <Button
                            color="primary"
                            style={{ margin: 20 }}
                            onClick={() => {
                                const dataImges = this.props.data;
                                history.push({
                                    pathname: process.env.PUBLIC_URL + '/assitencial/daicoms',
                                    state: { 
                                        dataImg: dataImges,
                                        dataPatient: this.props.data
                                     }
                                });
                            }}
                        >
                            Abrir Imagenes
                        </Button>

                        <ModalMessage
                            color={this.state.modalAlert.color}
                            title={this.state.modalAlert.title}
                            message={this.state.modalAlert.message}
                            modal={this.state.openAlert}
                            toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                            onOk={() => { this.setState({ openAlert: !this.state.openAlert }) }}

                        />
                    </div>
                </div>
            </div>
        );
    }

}

export default reduxForm({
    form: `seccion-form`, // a unique identifier for this form
})(withTranslation('common')(ImagenologiaForm));